/**
 * Service: InventoryB2CApi
 */
angular.module('acme.common.service.inventoryB2CApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder'
])
.service('InventoryB2CApiService', ['$http', '$q', 'ApiVersionFactory', function($http, $q, ApiVersionFactory) {
    return {

      init: function(endpoint) {
        this.service = endpoint + '/b2c/inventories';
        return this;
      },

      /**
       * Get Event detail from B2C Inventory
       * @param eventId
       */
      detail: function(eventId) {
        var av = new ApiVersionFactory(),
          url = null;

        url = av.init({ url: this.service, version: 'v2' });

        return $http.get(url, {
          params: {
            eventIds: eventId
          }
        })
          .then(function(response) {

          var eventSummary = response.data.payload.filter(function(event) {
            return event.eventId === eventId;
          });

          return eventSummary[0] || $q.reject();
        });
      }
    };
}]);
